class BaseStore {
  constructor(routerStore, uiState) {
    this.routerStore = routerStore;
    this.uiState = uiState;
  }
}

export default BaseStore;
